module.exports = __webpack_public_path__ + "static/media/bow.d0f759c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Heathbot/bow.jpg
// module id = 187
// module chunks = 0